const version = '(v2.20.10.1)'

export default version
